import { inferDraftType } from '../features/import-note/composer/composerValidation';

const CONTENT_FIELDS = [
  'front', 'back', 'cardType', 'word', 'contextPre', 'memo', 'contextAfter',
  'backMemo', 'ttsText', 'readingTitle', 'readingContent', 'readingText',
  'readingSegments', 'readingCharacterNames',
];

export function editableCardContent(card = {}) {
  const content = {};
  CONTENT_FIELDS.forEach((field) => {
    if (card[field] !== undefined) content[field] = card[field];
  });
  if (content.front === undefined) content.front = card.question || '';
  if (content.back === undefined) content.back = card.answer || '';
  return content;
}

export function cardIdentity(card) {
  return card.id || card._id || card.clientId;
}

export function cardPayload(card) {
  return {
    ...(card.id || card._id ? { id: String(card.id || card._id) } : { clientId: card.clientId }),
    ...editableCardContent(card),
  };
}

export function cardPreview(card) {
  return {
    ...card,
    draftType: inferDraftType({
      ...card, question: card.front, answer: card.back,
      word: card.word ?? (card.cardType === 'simple' ? true : card.cardType === 'normal' ? false : undefined),
    }),
  };
}

export function cardToDraft(card) {
  const lines = [];
  const tag = (name, value) => {
    if (value !== undefined && value !== null && String(value).trim()) lines.push(`@${name}: ${value}`);
  };
  tag('pre', card.contextPre);
  tag('front', card.memo);
  tag('back', card.backMemo);
  tag('after', card.contextAfter);
  tag('tts', card.ttsText);
  if (card.cardType === 'reading') {
    tag('R', card.readingTitle || card.front);
    Object.entries(card.readingCharacterNames || {}).forEach(([speaker, name]) => tag(`${speaker} name`, name));
    if (Array.isArray(card.readingSegments) && card.readingSegments.length) {
      card.readingSegments.forEach((segment) => {
        tag(segment.type === 'scene' ? 'Scene' : segment.type === 'story' ? 'Story' : segment.speaker || 'A', segment.text);
      });
    } else {
      const content = card.readingContent || card.back || '';
      lines.push(/^\s*@(Story|Scene|A|B)\s*:/im.test(content) ? content : `@Story: ${content}`);
    }
  } else {
    tag('word', card.word ?? (card.cardType === 'simple'));
    tag('Q', card.front || card.question);
    tag('A', card.back || card.answer);
  }
  return `---\n${lines.join('\n')}\n---`;
}

export function describeCardChanges(originalCards, cards) {
  const originals = new Map(originalCards.map((card) => [String(cardIdentity(card)), editableCardContent(card)]));
  const remainingIds = new Set(cards.map((card) => String(cardIdentity(card))));
  return {
    added: cards.filter((card) => !originals.has(String(cardIdentity(card)))),
    modified: cards.filter((card) => originals.has(String(cardIdentity(card))) &&
      JSON.stringify(originals.get(String(cardIdentity(card)))) !== JSON.stringify(editableCardContent(card))),
    deleted: originalCards.filter((card) => !remainingIds.has(String(cardIdentity(card)))),
  };
}
